module.exports = __webpack_public_path__ + "img/cover.3550d4f8.jpg";